import { getAnalyticsClient } from './helpers';

/**
 * The Google Analytics client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name googleanalytics
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains any extra metadata that needs to be sent with every conversion event posted to the google analytics service
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function googleanalytics(config = {}, log, noPublish) {
  return {
    async trackEvent(eventName, eventData = {}) {
      const gaInstance = await getAnalyticsClient('ga');
      try {
        if (gaInstance && (typeof gaInstance.getAll === 'function')) {
          const trackEventGoogle = gaInstance.getAll()[0];
          if (trackEventGoogle && trackEventGoogle.send) {
            if (log) {
              log('[Analytics_GoogleGA_Event]', eventData);
            }
            if (!noPublish) {
              trackEventGoogle.send('event', eventData);
            }
          }
        }
      } catch (err) {
        log('[Analytics_GoogleGA_Event] Error', err);
      }
    }
  };
}

export default googleanalytics;
